// extracted by mini-css-extract-plugin
export default {"contact-info":"Contacts_contact-info__41rS8"};